import FormController from './form_controller';
import Events from '../classes/Events';
import axios from 'axios';

class ForgetPassword extends FormController {
  static targets = [
    'email',
    'errorMessage'
  ]

  targetNames() {
    return ForgetPassword.targets;
  }

  async sendPasswordReset() {
    this.element.setAttribute('data-transition-data', JSON.stringify({ email: this.emailTarget.value}))

    try {
      await axios.post('/users/reset_password/', {
        email: this.emailTarget.value
      })
      this.element.dispatchEvent(Events.submittedEvent);
    } catch(e) {
      this.element.dispatchEvent(Events.submittedEvent);
    }
  }
}

export default ForgetPassword;
